import React, { useRef } from 'react'

import { SignaturePad } from '../signature_pad'

export const SignaturePadField = ({
  height,
  width,
  input: { value, onChange },
}) => {
  const ref = useRef()

  return (
    <SignaturePad
      ref={ref}
      height={height}
      width={width}
      onEnd={(e) => {
        onChange(e)
      }}
    />
  )
}
